<template>
    <div class="fade-in">
        <div
            v-for="(item, index) in statusLogs"
            :key="item.uuid || index"
            class="border border-light rounded mb-3 overflow-hidden"
        >
            <div class="bg-light px-3 py-2">
                <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                    <h6 class="font-weight-bold mb-1 mb-sm-0">{{ item.candidateStatus ? item.candidateStatus.name : '--' }}</h6>
                    <small class="text-muted">{{ item.createdAt || '--' }}</small>
                </div>
            </div>
            <div class="p-3">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block">Email Subject</small>
                        <div class="font-weight-bold">{{ item.emailSubject || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block">Email To</small>
                        <div class="font-weight-bold">{{ item.emailTo || '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block">Email CC</small>
                        <div class="font-weight-bold">{{ emailCc(item) }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block">Remark</small>
                        <div>{{ item.remark || '--' }}</div>
                    </div>
                    <div class="col-md-12">
                        <small class="text-muted d-block">Email Content</small>
                        <div
                            v-if="item.emailContent"
                            class="border rounded p-2 bg-light"
                            v-html="item.emailContent"
                        ></div>
                        <div v-else>--</div>
                    </div>
                </div>
            </div>
        </div>
        <b-alert
            v-if="!statusLogs || statusLogs.length == 0"
            show
            variant="warning"
            class="text-center"
        >
            <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
        </b-alert>
    </div>
</template>
<script>
export default {
    props: {
        statusLogs: {
            type: Array,
            required: true,
        },
    },
    methods: {
        emailCc(log) {
            if (Array.isArray(log.emailCc)) return log.emailCc.join(', ') || '--';
            return log.emailCc || '--';
        },
    },
}
</script>
